import { PathRoutes } from 'enum/routes'

export enum CertificateTemplateTab {
  standard = 'standard',
  legal = 'legal',
}

export const CERTIFICATE_TEMPLATE_TAB_PATHS: Record<
  CertificateTemplateTab,
  string
> = {
  [CertificateTemplateTab.standard]: PathRoutes.CERTIFICATE_TEMPLATES_STANDARD,
  [CertificateTemplateTab.legal]: PathRoutes.CERTIFICATE_TEMPLATES_LEGAL,
}

export const isCertificateTemplateTabSlug = (
  value?: string
): value is CertificateTemplateTab =>
  value === CertificateTemplateTab.standard ||
  value === CertificateTemplateTab.legal
